import { calculateTotalPointsScore } from './calculator/total-points';
import { ScoreIf } from './score-type/score-if';

export interface ScoreResultIf {
  points: number;
  totalPoints: number;

  weightedPoints: number;
  totalWeightedPoints: number;

  droppedScores?: Array<ScoreIf>;
}

export interface CalculationOptions {
  debug?: boolean;
  dropScores?: {
    dropLowScores?: number;
    dropHighScores?: number;
    studentsFavor?: boolean;
  };
}

export type CalculationType = 'TOTAL_POINTS';

export * from './score-type/index';

export let Calculator = {

  calculateScore: function (calculationType: CalculationType = 'TOTAL_POINTS', scores?: Array<ScoreIf>, options?: CalculationOptions): ScoreResultIf | undefined {
    if (calculationType === 'TOTAL_POINTS') {
      return calculateTotalPointsScore(scores, options);
    } else {
      throw new Error('Unknown CalculationType');
    }
  }

};
